CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
BoardPlugin = require 'models/board-plugin'

module.exports = class BoardPluginList extends CollectionWithHelpers
  model: BoardPlugin

  initialize: (list, { board }) ->
    @board = board

  url: ->
    "/1/boards/#{ @board.id }/boardPlugins"



// WEBPACK FOOTER //
// ./app/scripts/models/collections/board-plugin-list.coffee